<template>
  <vf-input
    v-model.trim="modelValue"
    v-bind="$props"
    data-test-id="input-email"
    inputmode="email"
    :label="label || $t.email"
    name="email"
    :required
    type="email"
    @change="$emit('change', $event)"
  >
    <slot />
    <template v-if="$slots.before" #before>
      <slot name="before" />
    </template>
    <template v-if="$slots.after" #after>
      <slot name="after" />
    </template>
  </vf-input>
</template>

<script lang="ts" setup>
import type { Emits, Props, Slots } from '#brands/components/vf/input/Input.vue'

const { required = true } = defineProps<Omit<Props, 'min' | 'max' | 'type' | 'label'> & { label?: string }>()

defineEmits<Emits>()

defineSlots<Slots>()

const modelValue = defineModel<string | number>()
</script>
